// Added by Sejune Oh on 2019-06-25
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { UserRouterParams } from '@/pages/setting/mgmt/users/UserRouter'
import { withMgmtFormTemplate } from '@/components/common/Template/MgmtFormTemplate'
import { UserBase } from './UserBase'

const UserAddContainer = withMgmtFormTemplate<UserRouterParams>(UserBase({ type: 'add' }))
const UserDetailContainer = withMgmtFormTemplate<UserRouterParams>(UserBase({ type: 'edit' }))

export { UserAddContainer, UserDetailContainer }
export { default as UserList } from './UserList'
export { default as ResetUserPassword } from './ResetUserPassword'
export { default as UserConfigDialog } from './UserConfigDialog'
export * from './SystemAdminAdd'
